export const insights = {
  prsDataFile: "https://report.seesense.cc/data/ride_surveys.csv",
  irDataFile: "https://report.seesense.cc/data/report_dashboard_mock_data_infra_report.csv"
};

//ADD S3 FILE PATHS I THIS FILE HERE
